import { api } from "@/api/axios.ts";
import { ApiApprovalPolicy } from "@/types/approvals/approval-policy.types.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiJob,
  ApiJobHistory,
  ApiJobRequirements,
  ApiJobSavePayload,
  ApiJobsFilter,
  JobPriority,
} from "@/types/recruit/job.types.ts";

export const apiJobs = {
  create: (payload: ApiJobSavePayload) => {
    return api.post<ApiJob>("/api/v1/jobs", payload);
  },
  update: (id: number, payload: ApiJobSavePayload) => {
    return api.put<ApiJob>(`/api/v1/jobs/${id}`, payload);
  },
  search: (filter: ApiJobsFilter, signal?: AbortSignal) => {
    return api.post<ApiPagedData<ApiJob>>("/api/v1/jobs/search", filter, signal);
  },
  getById: (id: number) => {
    return api.get<ApiJob>(`/api/v1/jobs/${id}`);
  },
  duplicate: (id: number) => {
    return api.post<ApiJob>(`/api/v1/jobs/${id}/duplicate`, {});
  },
  getByListOfId: (ids: number[], includeCandidatesCount: boolean = false) => {
    return api.post<ApiJob[]>(`/api/v1/jobs/get-by-ids`, {
      job_ids: ids,
      include_candidates_count: includeCandidatesCount,
    });
  },
  recruitersSearch: (signal?: AbortSignal) => {
    return api.post<ApiPagedData<ApiEmployee>>(
      "/api/v1/jobs/recruiters/search",
      { page_number: 1 },
      signal
    );
  },
  approvalPolicies: () => {
    return api.get<ApiApprovalPolicy[]>("/api/v1/jobs/approval-policies");
  },
  stakeholdersSearch: (signal?: AbortSignal) => {
    return api.post<ApiPagedData<ApiEmployee>>(
      `/api/v1/jobs/stakeholders/search`,
      { page_number: 1 },
      signal
    );
  },
  generateRequirements: (payload: ApiJobSavePayload) => {
    return api.post<ApiJobRequirements>(`/api/v1/jobs/generate-requirements`, payload);
  },
  getHistory: (id: number) => {
    return api.get<ApiJobHistory>(`/api/v1/jobs/${id}/history`);
  },
  patchPriority: (id: number, priority: JobPriority | null) => {
    return api.patch<ApiJob>(`/api/v1/jobs/${id}/priority`, { priority });
  },
};
